// node_modules
import { FC } from "react";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// styles
import styles from "./notificationMessage.module.scss";

type TNotificationMessageProps = {
    message: string
};

export const NotificationMessage: FC<TNotificationMessageProps> = ({message}: TNotificationMessageProps) => {
    return (
        <div>
            <FontAwesomeIcon icon={faBell} className={styles.notificationIcon} />
            <span className={styles.notificationMessageContainer}>{message}</span>
        </div>
    );
}